import React, {useState} from 'react';
import {Carousel} from 'antd';
import {useLanguage} from '../contexts/LanguageContext';
import classNames from 'classnames';

const contentData = {
    title: {
        zh: '优势和保障',
        en: 'Advantages and Guarantees'
    },
    items: [
        {
            icon: '🎨',
            title: {
                zh: '创新设计 一站式服务',
                en: 'Innovative Design & One-Stop Solutions'
            },
            description: {
                zh: '提供从展台设计、创意图形、制作到安装拆除的全方位服务。我们的专业设计团队具有创新思维和国际视野，为客户打造独特的品牌展示方案，让客户专注于品牌推广的其他重要环节。',
                en: 'We provide comprehensive services from booth design, creative graphics, production to installation and dismantling. Our professional design team brings innovative thinking and international perspective to create unique brand exhibition solutions.'
            },
            image: 'https://storage.googleapis.com/sine_assets/palm_reading_pictures/8547acf9-5891-43f4-9947-e3e58f9eba33.jpg'
        },
        {
            icon: '👥',
            title: {
                zh: '专业团队执行',
                en: 'Professional Team Execution'
            },
            description: {
                zh: '拥有丰富的全球展会运营经验，我们的团队在展览策划、设计、执行等各个环节都拥有专业的解决方案。现场服务团队确保每个项目都能安全、顺利、高效地完成。',
                en: 'With rich global exhibition operation experience, our team offers professional solutions in exhibition planning, design, and execution. Our on-site service team ensures safe, smooth, and efficient completion of each project.'
            },
            image: 'https://storage.googleapis.com/sine_assets/palm_reading_pictures/2da1267b-4baa-4ac9-8b14-fbadbe8b7e6b.jpg'
        },
        {
            icon: '🏭',
            title: {
                zh: '北美多地仓储与制造',
                en: 'North American Warehouses & Manufacturing'
            },
            description: {
                zh: 'RunTop在北美设有多个仓储物流中心和自有工厂，确保快速响应客户需求，提供高效的生产和物流支持。我们的制造能力和仓储网络让我们能够为客户提供更具竞争力的展览解决方案。',
                en: 'RunTop operates multiple warehouses and manufacturing facilities across North America, ensuring quick response to client needs with efficient production and logistics support. Our manufacturing capabilities and storage network enable us to provide competitive exhibition solutions.'
            },
            image: 'https://storage.googleapis.com/sine_assets/palm_reading_pictures/3e9dae04-35de-4400-a676-666c68d5204e.jpg'
        }
    ]
};
const ChooseUs: React.FC = () => {
    const {currentLang} = useLanguage();
    const [activeIndex, setActiveIndex] = useState(0);
    const carouselRef = React.useRef<any>();

    // 处理内容点击
    const handleContentClick = (index: number) => {
        setActiveIndex(index);
        carouselRef.current?.goTo(index);
    };

    // 处理悬停
    const handleContentHover = (index: number) => {
        setActiveIndex(index);
        carouselRef.current?.goTo(index);
    };

    return (
        <div className="container mx-auto px-4 py-12">
            {/* 标题区域 */}
            <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-center mb-16">
                    {contentData.title[currentLang]}
                </h2>
            </div>

            {/* 主要内容区域 */}
            <div className="flex flex-col lg:flex-row gap-8">
                {/* 左侧内容列表 */}
                <div className="lg:w-2/5 space-y-4">
                    {contentData.items.map((item, index) => (
                        <div
                            key={index}
                            className={classNames(
                                'p-6 rounded-lg cursor-pointer transition-all duration-300',
                                'hover:shadow-lg',
                                {
                                    'bg-orange-50 border-l-4 border-orange-500': activeIndex === index,
                                    'bg-white': activeIndex !== index
                                }
                            )}
                            onClick={() => handleContentClick(index)}
                            onMouseEnter={() => handleContentHover(index)}
                            role="button"
                            tabIndex={0}
                        >
                            <div className="flex items-center gap-3 mb-3">
                                <span className="text-orange-500 text-2xl">{item.icon}</span>
                                <h3 className="font-bold text-lg text-left"> {/* 添加 text-left */}
                                    {item.title[currentLang]}
                                </h3>
                            </div>
                            <p className="text-gray-600 leading-relaxed text-left"> {/* 添加 text-left */}
                                {item.description[currentLang]}
                            </p>
                        </div>
                    ))}
                </div>

                {/* 右侧图片轮播 */}
                <div className="hidden lg:block lg:w-3/5">
                    <Carousel
                        ref={carouselRef}
                        effect="fade"
                        autoplay={false}
                        dots={false}
                        afterChange={(current) => setActiveIndex(current)}
                    >
                        {contentData.items.map((item, index) => (
                            <div key={index}>
                                <div className="relative overflow-hidden">
                                    <img
                                        src={item.image}
                                        alt={item.title[currentLang]}
                                        className="w-full object-cover rounded-lg transition-transform duration-300 ease-in-out hover:scale-105"
                                    />
                                </div>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </div>

            {/* 移动端指示器 */}
            <div className="flex justify-center gap-2 mt-6 lg:hidden">
                {contentData.items.map((_, index) => (
                    <div
                        key={index}
                        className={classNames('w-2 h-2 rounded-full transition-all', {
                            'bg-orange-500': activeIndex === index,
                            'bg-gray-300': activeIndex !== index
                        })}
                        onClick={() => handleContentClick(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default ChooseUs;
